import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import FindProStep from '../FindProStep';

import styles from './FindProGroup.module.scss';

interface Props {
  content?: {
    chooseProfessional?: string;
    enterDetails?: string;
    receiveQuote?: string;
  };
}

const FindProGroup: FC<Props> = ({ content }) => {
  const { t } = useTranslation();

  const findProStepsContent: Record<string, Record<string, string>> = {
    chooseProfessional: {
      description:
        content?.chooseProfessional ??
        t('marketingPages:seo.landingPage.howToSearchAPro.chooseProfessional.content'),
      imageUrl: '/static/images/icons/Client_flow_003.svg',
      title: t('marketingPages:seo.landingPage.howToSearchAPro.chooseProfessional.title'),
    },
    enterDetails: {
      description:
        content?.enterDetails ??
        t('marketingPages:seo.landingPage.howToSearchAPro.enterDetails.content'),
      imageUrl: '/static/images/icons/Client_flow_001.svg',
      title: t('marketingPages:seo.landingPage.howToSearchAPro.enterDetails.title'),
    },
    receiveQuote: {
      description:
        content?.receiveQuote ??
        t('marketingPages:seo.landingPage.howToSearchAPro.receiveQuote.content'),
      imageUrl: '/static/images/icons/Client_flow_002.svg',
      title: t('marketingPages:seo.landingPage.howToSearchAPro.receiveQuote.title'),
    },
  };

  return (
    <div className={styles['container']} data-test-id="find-pro-section">
      <h2 className={styles['title']}>
        {t('marketingPages:seo.landingPage.howToSearchAPro.contentTitle')}
      </h2>
      <div className={styles.steps}>
        <FindProStep
          description={findProStepsContent.enterDetails.description}
          imageUrl={findProStepsContent.enterDetails.imageUrl}
          title={findProStepsContent.enterDetails.title}
        />
        <FindProStep
          description={findProStepsContent.receiveQuote.description}
          imageUrl={findProStepsContent.receiveQuote.imageUrl}
          title={findProStepsContent.receiveQuote.title}
        />
        <FindProStep
          description={findProStepsContent.chooseProfessional.description}
          imageUrl={findProStepsContent.chooseProfessional.imageUrl}
          title={findProStepsContent.chooseProfessional.title}
        />
      </div>
    </div>
  );
};

export type { Props as FindProGroupProps };
export default FindProGroup;
